
angular.module('listviewModule').component('listviewRowImages', {
	templateUrl: 'listviewRowImages/listviewRowImages.html',
	bindings: {
		item: '=',
		showViewer: '=',
		useFullScreenPopup: '<',
		isForBuilding: '<'
	},
	controller: ['$element', '$window', '$timeout', function($element, $window, $timeout) {
		var ctrl = this;
		var w = angular.element($window);
		var parent = angular.element($element[0].parentElement);
		var boxWrapper = angular.element($element[0].querySelector('.box_wrapper'));
		var activeSlideIndex = 0;
		var imageCounts = this.item.images.length;
		var paddingParent = Number(parent.css('padding-left').replace('px', '')) + Number(parent.css('padding-right').replace('px', ''));

		if (boxWrapper.length === 0) {
			return;
		}

		w.bind('resize', function() {
			var parentWidth = $(parent[0]).clientWidth - paddingParent;
			this.allowedVisibleItems = parentWidth / this.imageWidth;

			var newWidth = $(parent[0]).clientWidth - boxWrapper.posLeft;
			boxWrapper.css({
				width: newWidth + 'px'
			});

			// hide rightNav if the last item is already display when resizing the window.
			if (ctrl.isLastItemVisible()) {
				this.showRightNav = false;
			} else {
				this.showRightNav = true;
			}
		});


		this.isLastItemVisible = function() {
			var parentWidth = $(parent[0]).clientWidth - paddingParent;
			return (((this.imageWidth * imageCounts) + boxWrapper.posLeft) <= parentWidth);
		};

		this.getImageInfo = function() {
			var images = $(boxWrapper[0]).querySelectorAll('.image_wrapper');
			var parentWidth = $(parent[0]).clientWidth - paddingParent;

			this.imageWidth = $(images[0]).getBoundingClientRect().width + 10;
			this.allowedVisibleItems = parentWidth / this.imageWidth;
		};

		this.moveLeft = function() {
			var parentWidth = $(parent[0]).clientWidth - paddingParent;
			var value = ((boxWrapper.posLeft) ? boxWrapper.posLeft : 0) - this.imageWidth;
			var width = boxWrapper.currentWidth = parentWidth - value;

			if (activeSlideIndex + this.allowedVisibleItems.toInt() === imageCounts) {
				this.showRightNav = false;
			}

			this.showLeftNav = true;

			activeSlideIndex++;

			boxWrapper.css({
				width: width + 'px',
				left: value + 'px'
			});

			boxWrapper.posLeft = value;
		};

		this.moveRight = function() {
			var parentWidth = $(parent[0]).clientWidth - paddingParent;
			var value = ((boxWrapper.posLeft) ? boxWrapper.posLeft : 0) + this.imageWidth;
			var width = boxWrapper.currentWidth = parentWidth - value;
			boxWrapper.posLeft = value;
			activeSlideIndex--;

			if (activeSlideIndex === 0) {
				this.showLeftNav = false;
			}

			// hide right nav button if the last image is already visible.
			if (this.isLastItemVisible()) {
				this.showRightNav = false;
			} else {
				this.showRightNav = true;
			}

			boxWrapper.css({
				left: value + 'px'
			});

			// To hide the image smoothly when moving the list to the right.
			$timeout(function() {
				boxWrapper.css({
					width: width + 'px'
				});
			}, 500);
		};


		$timeout(function() {
			var parentWidth = $(parent[0]).clientWidth - paddingParent;
			boxWrapper.posLeft = 0;
			ctrl.getImageInfo();

			// check if we have to display the right arrow
			if (ctrl.imageWidth * imageCounts > parentWidth) {
				ctrl.showRightNav = true;
			}
		});
	}]
});
